import React, { useEffect, useState } from "react";
import {firebaseApp} from "../libs/firebase"
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { setSentryUser, clearSentryUser } from '../libs/sentry';
import { logoutAnalytics, noteAnalyticsSignIn } from '../libs/analyticsManager';

//https://github.com/satansdeer/react-firebase-auth
export const AuthContext = React.createContext({ currentUser: null });

// mb_authed steers the Cloudflare homepage Worker (issue #3829): logged-in
// visitors hitting / skip the proxied marketing page and reach the app.
const syncAuthCookie = (user) => {
  try {
    document.cookie = user
      ? "mb_authed=1; path=/; max-age=2592000; SameSite=Lax"
      : "mb_authed=; path=/; max-age=0; SameSite=Lax";
  } catch (e) {
    // best-effort only — without the cookie the Worker just shows the
    // marketing page, which links back into the app
  }
};

export const AuthProvider = ({ children, uid }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [pending, setPending] = useState(true);
  useEffect(() => {
    if(!uid) {
      onAuthStateChanged( getAuth(firebaseApp), (user) => {
        //await fetchProfile(user)
        //if (user!=null) return user;
        setCurrentUser(user)
        setPending(false)
        syncAuthCookie(user)

        // Set Sentry context when user state changes
        try {
          if (user) {
            setSentryUser(user);
            noteAnalyticsSignIn();
          } else {
            clearSentryUser();
            logoutAnalytics();
          }
        } catch (error) {
          console.error('Error setting Sentry context', error);
        }
      })
    } else {
      const user = {uid: uid}
      setCurrentUser(user)
      setPending(false)
    }
  }, []);
  if(pending){
    return <>Loading...</>
  }
  return (
    <AuthContext.Provider
      value={{currentUser}} >
      {children}
    </AuthContext.Provider>
  );
};
